import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  toggleAllChecks(clickEvent) {
    const sections = this.element.querySelectorAll('.filter-section');
    sections.forEach((section) => {
      let button = section.querySelector('ion-button');
      if (button) {
        button.click();
      }
    });

    let button = this.element.querySelector('ion-button');
    if (button.textContent == 'Uncheck all') {
      this.setTextContent(button, 'Check all');
      this.setIcon(button, 'checkbox');
    } else {
      this.setTextContent(button, 'Uncheck all');
      this.setIcon(button, 'checkbox-outline');
    }
  }

  setTextContent(buttonElement, text) {
    buttonElement.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = text;
      }
    });
  }

  setIcon(buttonElement, iconName) {
    const startIcon = buttonElement.querySelector('[slot="start"]');
    if (startIcon) {
      startIcon.setAttribute('name', iconName);
    }
  }

  toggleChecks(clickEvent) {
    let button = this.element.querySelector('ion-button');
    if (this.element.dataset.checked == 'true') {
      // uncheck all and set button
      this.element.querySelectorAll('ion-checkbox').forEach((checkbox) => {
        checkbox.checked = false;
        const event = new Event('ionChange', { bubbles: true });
        checkbox.dispatchEvent(event);
      });
      this.setTextContent(button, 'Check section');
      this.setIcon(button, 'checkbox');
      this.element.dataset.checked = false;
    } else {
      // check all and set button
      this.element.querySelectorAll('ion-checkbox').forEach((checkbox) => {
        checkbox.checked = true;
        const event = new Event('ionChange', { bubbles: true });
        checkbox.dispatchEvent(event);
      });
      this.setTextContent(button, 'Uncheck section');
      this.setIcon(button, 'checkbox-outline');
      this.element.dataset.checked = true;
    }
  }
}
